import { Box, Container, Grid } from "@mui/material";
import { useUserInfo } from "../../utils/security";
import { TotalsCard } from "./TotalsCard";
import { CashflowChart } from "./CashflowChart";
import { TransactionTypesChart } from "./TransactionTypesChart";
import {
    ListDetailViewSectionContent,
    ListDetailViewSectionHeader,
    ListDetailViewSectionLayout,
} from "../../components/ListDetailView";
import { AddOutlined, EventRepeatOutlined } from "@mui/icons-material";
import { PeriodSelector } from "../../components/Period";
import { useContext } from "react";
import { FilterContext } from "../../components/Filter";

export const FinancialsOverviewContent = ({ data, loading }) => {
    const { userInfo } = useUserInfo();
    const currencyCode = data?.currencyCode || userInfo.defaultCurrencyCode;

    return (
        <>
            <Box sx={{ py: 4, display: "flex", flexWrap: "wrap", gap: 5 }}>
                <TotalsCard
                    data={data?.totals?.income}
                    currencyCode={currencyCode}
                    title="Příjmy"
                    loading={loading}
                />
                <TotalsCard
                    data={data?.totals?.expenditure}
                    currencyCode={currencyCode}
                    title="Výdaje"
                    factor={-1}
                    loading={loading}
                />
                <TotalsCard
                    data={data?.totals?.balance}
                    currencyCode={currencyCode}
                    title="Celkem"
                    loading={loading}
                />
            </Box>
            <Box sx={{ py: 4 }}>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={6} lg={12} xl={6}>
                        <CashflowChart
                            data={data?.cashflow?.data}
                            loading={loading}
                            currencyCode={currencyCode}
                            height={402}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} lg={12} xl={6}>
                        <TransactionTypesChart data={data?.transactionTypes} loading={loading} />
                    </Grid>
                </Grid>
            </Box>
        </>
    );
};

export const FinancialsOverview = ({
    data,
    loading,
    onAddTransaction,
    onShowRecurringDialog,
    ...others
}) => {
    const { userInfo } = useUserInfo();
    const { setFilter, filter } = useContext(FilterContext);

    console.log(others);

    return (
        <ListDetailViewSectionLayout loading={loading}>
            <ListDetailViewSectionHeader
                title="Přehled financí"
                titleNode={
                    <PeriodSelector
                        value={filter.period}
                        onChange={(period) => setFilter({ ...filter, period })}
                        disabled={loading}
                        withDetail
                    />
                }
                role="overview"
                loading={loading}
                actions={[
                    {
                        title: "Přidat opakovanou transakci",
                        icon: <EventRepeatOutlined />,
                        onClick: onShowRecurringDialog,
                    },
                    {
                        title: "Přidat transakci...",
                        icon: <AddOutlined />,
                        items: (userInfo?.transactionTypes || []).map((transactionType) => ({
                            title: transactionType.name,
                            icon: <AddOutlined />,
                            onClick: () => onAddTransaction?.(transactionType),
                        })),
                    },
                ]}
            />
            <ListDetailViewSectionContent>
                {/*<PeriodField />*/}
                <Container maxWidth="xl">
                    <FinancialsOverviewContent data={data} loading={loading} />
                </Container>
            </ListDetailViewSectionContent>
        </ListDetailViewSectionLayout>
    );
};
